/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsListMcpEndpoints } from "../funcs/domainsListMcpEndpoints.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListCustomDomainMcpEndpointsResult } from "../models/components/listcustomdomainmcpendpointsresult.js";
import {
  ListCustomDomainMcpEndpointsRequest,
  ListCustomDomainMcpEndpointsSecurity,
} from "../models/operations/listcustomdomainmcpendpoints.js";
import { unwrapAsync } from "../types/fp.js";
export type CustomDomainMcpEndpointsQueryData =
  ListCustomDomainMcpEndpointsResult;

export function prefetchCustomDomainMcpEndpoints(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListCustomDomainMcpEndpointsRequest | undefined,
  security?: ListCustomDomainMcpEndpointsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildCustomDomainMcpEndpointsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildCustomDomainMcpEndpointsQuery(
  client$: GramCore,
  request?: ListCustomDomainMcpEndpointsRequest | undefined,
  security?: ListCustomDomainMcpEndpointsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<CustomDomainMcpEndpointsQueryData>;
} {
  return {
    queryKey: queryKeyCustomDomainMcpEndpoints({
      gramSession: request?.gramSession,
    }),
    queryFn: async function customDomainMcpEndpointsQueryFn(
      ctx,
    ): Promise<CustomDomainMcpEndpointsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(domainsListMcpEndpoints(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyCustomDomainMcpEndpoints(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "domains", "listMcpEndpoints", parameters];
}
